import AbstractController from '../src/services/ControllersRepository/AbstractController';
import ProductCreateForm from '@views/products/ProductCreateForm';
import ProductUpdateForm from '@views/products/ProductUpdateForm';

export default class Products extends AbstractController {
    protected controllerName = 'Products';

    protected getDefaultCreateFormComponent() {
        return ProductCreateForm;
    }

    protected getDefaultUpdateFormComponent() {
        return ProductUpdateForm;
    }
}
